import {apiRequest} from "../helpers/utils";

export const offerServices = {
    create,
    update,
    archive,
    find,
    restore,
    read,
    bulkUpdate,
    bulkUpdateForUrl
};

function read(name, countryCode, includeGlobalCountries) {
    let params = {
        name,
        countryCode,
        isDeleted: false,
        pageSize: 250,
        includeGlobalCountries
    };
    return apiRequest("get", "v1/offer", {}, params);
}

function create(formData) {
    return apiRequest("post", "v1/offer", formData);
}

function update(offerId, formData) {
    return apiRequest("put", "v1/offer/" + parseInt(offerId), formData);
}

function archive(formData) {
    return apiRequest("post", "v1/offer/archive", formData);
}

function restore(formData) {
    return apiRequest("post", "v1/offer/restore", formData);
}

function find(offerId) {
    return apiRequest("get", "v1/offer/" + parseInt(offerId));
}

function bulkUpdate(formData) {
    return apiRequest("patch", "v1/offer", formData);
}

function bulkUpdateForUrl(formData) {
    return apiRequest("patch", "v1/offer/url", formData);
}